// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"button-primary_btn-primary__1jD5m"};